// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__rQoc6","header":"Modal_header__Axdlb","title":"Modal_title__kVoSr","close-button":"Modal_close-button__Dfgz9"};